import { DateTime } from 'luxon';

export const sortWatchListByDate = (watchList) =>
  watchList.sort((a, b) => DateTime.fromISO(b.createdAt).toMillis() - DateTime.fromISO(a.createdAt).toMillis());

export const sortWatchListAlphabetically = (watchList) =>
  watchList.sort((a, b) => {
    const name1 = a.name.replace(/\s/g, '');
    const name2 = b.name.replace(/\s/g, '');
    return name1.localeCompare(name2);
  });

export const sortWatchListByAmountDesc = (watchList) =>
  watchList.sort((a, b) => Math.abs(b.yearToDate) - Math.abs(a.yearToDate));

export const sortWatchListByAmountAsc = (watchList) =>
  watchList.sort((a, b) => Math.abs(a.yearToDate) - Math.abs(b.yearToDate));

export const sortWatchList = (swlData, swlOrder) => {
  if (!swlData) {
    return swlData;
  }
  switch (swlOrder) {
    case 'BY_DATE':
      return sortWatchListByDate(swlData);
    case 'BY_ALPHABET':
      return sortWatchListAlphabetically(swlData);
    case 'BY_AMOUNT_DESC':
      return sortWatchListByAmountDesc(swlData);
    case 'BY_AMOUNT_ASC':
      return sortWatchListByAmountAsc(swlData);
    default:
      return sortWatchListByDate(swlData);
  }
};

export const separateFutureAndPastTxns = (txnItemsArray) => {
  const today = DateTime.local().toISODate();
  return (txnItemsArray || []).reduce(
    (accumulator, item) => {
      const txn = item.transaction || item; // Handle plain transaction objects or objects with 'transaction' property
      const isFuture =
        (txn.postedOn || txn.stDueOn) > today ||
        txn.source === 'SCHEDULED_TRANSACTION_PENDING' ||
        (txn.subtype === 'REFUND' && txn.state === 'PENDING');
      if (isFuture) {
        accumulator.txnsItemsUpcoming.push(item);
        if (!accumulator.txnsUpcoming.includes(txn)) {
          accumulator.txnsUpcoming.push(txn);
        }
      } else {
        accumulator.txnsItemsWithoutUpcoming.push(item);
        if (!accumulator.txnsWithoutUpcoming.includes(txn)) {
          accumulator.txnsWithoutUpcoming.push(txn);
        }
      }
      return accumulator;
    },
    {
      txnsWithoutUpcoming: [],
      txnsUpcoming: [],
      txnsItemsWithoutUpcoming: [],
      txnsItemsUpcoming: [],
    },
  );
};
